import React, { useState, useEffect, useRef } from 'react';
//import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement, Filler } from 'chart.js';
import {
	Chart as ChartJS,
	LineController, LineElement, // <-- Add these if not already imported
	CategoryScale, LinearScale,
	BarElement, Title, Tooltip, Legend,
	ArcElement, PointElement, Filler
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import './home.css';
import { doghnutLineLabel } from './charts.js';
import { useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import { Helmet } from 'react-helmet';
import { fill } from 'three/src/extras/TextureUtils.js';
import * as XLSX from 'xlsx';
import ScrollBooster from "scrollbooster";
import JSZip from "jszip";
import { saveAs } from "file-saver";

//ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement, Filler);
ChartJS.register(LineController, LineElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, Filler);
function Home({ onLogout }) {
	const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
	const navigate = useNavigate(); // Create a navigate function
	const [data, setData] = useState(null);
	const [combinedData, setCombinedData] = useState({ leads: [], meetings: [] });
	const [weekRange, setWeekRange] = useState('');
	const [bookedWeekly, setBookedWeekly] = useState(0);
	const [doneWeekly, setDoneWeekly] = useState(0);
	const [companyNames, setCompanyNames] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState('Overview');
	const [showCompanies, setShowCompanies] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [barChartData, setBarChartData] = useState(null);
	const [doughnutChartData, setDoughnutChartData] = useState(null);
	const [leadsData, setLeadsData] = useState([]);
	const [currentSeller, setCurrentSeller] = useState('');
	const [dropDown, setDrodown] = useState(false);
	const earliestDate = useRef(new Date());
	const [warmLeadFilters, setWarmLeadFilters] = useState(false);

	const cities = useRef(new Set());
	const positions = useRef(new Set());

	const [getCitiesFilter, setCitiesFilter] = useState(null);
	const [getDateFilter, setDateFilter] = useState(null);
	const [getPositionFilter, setPositionFilter] = useState(null);

	const barChartRef = useRef(null);
	const doughnutChartRef = useRef(null);

	useEffect(() => {
		if (isLoading) {
			document.body.style.overflow = 'hidden'; // Hide scrollbar
		} else {
			document.body.style.overflow = 'auto'; // Show scrollbar
		}
	}, [isLoading]);

	useEffect(() => {

		fetchData();

		new ScrollBooster({
			viewport: document.getElementsByClassName('leads-table-container')[0],
			content: document.getElementById('leads-table-content'),
			scrollMode: 'native',
			direction: 'horizontal'
		});

	}, []);

	const fetchData = async () => {
		try {
			setIsLoading(true);
			const response = await fetch(`${API_ENDPOINT}/login.php`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					token: localStorage.getItem('token'),
					token_expiry: localStorage.getItem('token_expiry'),
					username: localStorage.getItem('username'),
				}),
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			//const resultText = await response.text();
			//console.log(resultText);
			const result = await response.json();
			if (result.success) {
				setData(result.data);
				setCompanyNames(result.companies);
				processData(result.data, result.companies);
			} else {
				if (result.error == "E_INCORRECT_TOKEN") {
					onLogout();
				}
				console.error('Error fetching data:', result.error);
			}
		} catch (error) {
			console.error('There was a problem with the fetch operation:', error);
		} finally {
			setIsLoading(false);
		}
	};

	const getWeekNumber = (date) => {
		//getting earliest date to make mettings chart
		if (earliestDate.current > date) {
			earliestDate.current = date;
		}
		// Set the starting date for week counting (e.g., January 1, 2023)
		const startingDate = new Date("2023-01-02");

		// Calculate the time difference in milliseconds between the given date and the starting date
		const timeDiff = date - startingDate;

		// Convert the time difference to weeks, and add 1 to account for the first week
		const weekNumber = Math.ceil((timeDiff / 86400000) / 7) + 1;

		return weekNumber;
	}

	const adjustKeys = (jsonString) => {
		// Parse the JSON string into an object
		const obj = jsonString;

		// Get the keys of the object
		const keys = Object.keys(obj);
		// Find the minimum key
		const minKey = Math.min.apply(Math, keys) - 1;

		// Create a new object with adjusted keys
		const adjustedObj = {};

		keys.forEach(key => {
			adjustedObj[key - minKey] = jsonString[key];

		});

		return adjustedObj;
	}
	const curr = (obj, j) => {

		return obj[j];
	};
	const zero = (obj, j) => {
		return 0;
	};

	function getFutureMonday(startDate, weekNumber) {
		const date = new Date(startDate);
		if (isNaN(date)) {
			throw new Error("Invalid date provided");
		}
		date.setHours(0, 0, 0, 0);
		date.setDate(date.getDate() - date.getDay() + 1);
		date.setDate(date.getDate() + 7 * weekNumber);

		return date;
	}

	const fillMissingKeys = (obj, val) => {
		// Get all keys and sort them numerically
		const keys = Object.keys(obj).map(Number).sort((a, b) => a - b);

		// Iterate over sorted keys
		for (let i = 0; i < keys.length - 1; i++) {
			const currentKey = keys[i];
			const nextKey = keys[i + 1];

			// If there's a gap between keys, fill it with the value of the previous key
			if (nextKey - currentKey > 1) {
				for (let j = currentKey + 1; j < nextKey; j++) {
					obj[j] = val(obj, currentKey) //obj[currentKey];
				}
			}
		}

		const adj_keys = Object.keys(obj).map(Number).sort((a, b) => a - b);
		const date_obj = {};
		for (let i = 0; i < adj_keys.length; i++) {
			date_obj[getFutureMonday(earliestDate.current, i).toLocaleString('default', { month: 'short', day: 'numeric' })] = obj[i] !== undefined && !isNaN(obj[i]) ? obj[i] : 0;
		}

		return date_obj;

	}

	const processData = (rawData, companies) => {
		setWeekRange(getDateRange());
		let meetings_count = 0;
		let meetings_done = 0;

		
		const combined = { leads: [], meetings: [] };
		let meetingsWeekly = {}
		if (companies.length > 1) {
			companies.forEach(company => {
				combined.leads = combined.leads.concat(rawData[company].leads);
				rawData[company]['meetings'].forEach(fields => {
					if (new Date(fields['fields']['Current Date']) > new Date(rawData[company]['cutoff_date'])) {
						const dateString = fields['fields']['Current Date']; // Example date string
						const meetingDate = new Date(dateString);
						const weekNumber = getWeekNumber(meetingDate);
						// Increment the count for the corresponding week number
						/*if (weekNumber=='56'){
						  console.log(fields);
						}*/
						if (meetingsWeekly.hasOwnProperty(weekNumber)) {
							meetingsWeekly[weekNumber] += 1;
						} else {
							meetingsWeekly[weekNumber] = 1;
						}
						meetings_count += 1;

						if (fields['fields']['Status'] === 'Executed') {
							meetings_done += 1;
						}
					}

				});

				combined.meetings = combined.meetings.concat(rawData[company].meetings);
			});
		} else {
			let company = companies[0];
			combined.leads = combined.leads.concat(rawData[company].leads);
			rawData[company]['meetings'].forEach(fields => {

				if (new Date(fields['fields']['Current Date']) > new Date(rawData[company]['cutoff_date'])) {
					const dateString = fields['fields']['Current Date']; // Example date string
					const meetingDate = new Date(dateString);
					const weekNumber = getWeekNumber(meetingDate);

					// Increment the count for the corresponding week number
					if (meetingsWeekly.hasOwnProperty(weekNumber)) {
						meetingsWeekly[weekNumber] += 1;
					} else {
						meetingsWeekly[weekNumber] = 1;
					}
					meetings_count += 1;
					if (fields['fields']['Status'] === 'Executed') {
						meetings_done += 1;
					}
				}

			});

			combined.meetings = combined.meetings.concat(rawData[company].meetings);
		}
		const test = adjustKeys(meetingsWeekly);
		//console.log(test);
		meetingsWeekly = fillMissingKeys(test, zero);
		//console.log(meetingsWeekly);
		setCombinedData(combined);

		const meetingsData = dataProcess(combined.meetings);
		setBookedWeekly(meetings_count);
		setDoneWeekly(meetings_done);

		setLeadsData(leadsProcess(combined.leads));

		let bar_values = {};
		let cumulativeTotal = 0;

		for (const key in meetingsWeekly) {

			//console.log(meetingsWeekly[key]);
			//console.log(cumulativeTotal);

			cumulativeTotal += meetingsWeekly[key];
			bar_values[key] = cumulativeTotal;
		}

		updateCharts(meetingsData, meetingsWeekly, bar_values);
	};

	const getDateRange = () => {
		const currentDate = new Date();
		//const oneWeekAgo = new Date(currentDate);
		//oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

		const formatDate = (date) => date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

		//return `${formatDate(oneWeekAgo)} to ${formatDate(currentDate)}`;
		return `${formatDate(currentDate)}`;
	};

	const dataProcess = (meetings) => {
		const meetingTypes = {};
		let total_count = 0;
		let done_total = 0;

		meetings.forEach(meeting => {
			const status = meeting.fields.Status;
			if (!meetingTypes[status]) {
				meetingTypes[status] = 0;
			}
			meetingTypes[status]++;
			total_count++;
			if (status === 'Executed') {
				done_total++;
			}
		});

		// Merge 'Canceled' into 'Cancelled' if it exists
		if (meetingTypes['Canceled']) {
			meetingTypes['Cancelled'] = (meetingTypes['Cancelled'] || 0) + meetingTypes['Canceled'];
			delete meetingTypes['Canceled'];
		}

		return {
			meeting_type: meetingTypes,
			meeting_count: Object.values(meetingTypes),
			total_count,
			done_total
		};
	};

	const leadsProcess = (leads, forTable = false) => {
		if (leads.length === 0) {
			return [];
		}
		const uniquePositions = new Set(); // Use a Set to collect unique positions
		const uniqueCities = new Set(); // Use a Set to collect unique cities
		const sortedLeads = leads.sort((a, b) => {

			const modDate = new Date(a['Last modified time']);
			if (modDate > new Date(getDateFilter)) {
				a['City'] = a['City'] ? a['City'] : 'Uknown';
				a['Position'] = a['Position'] ? a['Position'] : 'Uknown';

				uniquePositions.add(a['Position']);

				uniqueCities.add(a['City']);
			}

			return new Date(b['Last modified time']) - new Date(a['Last modified time']);
		});
		positions.current = uniquePositions;
		cities.current = uniqueCities;

		if (forTable) {
			const filteredLeads = [];
			Object.keys(sortedLeads).forEach(key => {
				/*if(sortedLeads[key]['Last modified time'] !=  getDateFilter && getDateFilter){
				  console.log(sortedLeads[key]['Last modified time'])
				  console.log( getDateFilter)
				}
				if( sortedLeads[key]['City'] != getCitiesFilter && getCitiesFilter){
				  console.log( sortedLeads[key]['City'])
				  console.log(  getCitiesFilter)
				}
				if( sortedLeads[key]['Position'] !=  getPositionFilter && getPositionFilter){
				  console.log(sortedLeads[key]['Postion'])
				  console.log( getPositionFilter)
				}*/

				if ((new Date(sortedLeads[key]['Last modified time']) > getDateFilter || !getDateFilter) &&
					(sortedLeads[key]['City'] == getCitiesFilter || !getCitiesFilter) &&
					(sortedLeads[key]['Position'] === getPositionFilter || !getPositionFilter)) {
					filteredLeads.push(sortedLeads[key]);
				}
			});
			return filteredLeads;
		}



		//return forTable ? sortedLeads.slice(0, 5) : sortedLeads;
		return sortedLeads;
	};

	const updateCharts = (meetingsData, barMeetingsData, bar_values) => {

		const barData = {
			labels: Object.keys(barMeetingsData),
			datasets: [
				{
					label: 'Meetings Booked Per Week',
					yAxisID: 'A',
					data: barMeetingsData,
					backgroundColor: 'rgba(75, 192, 192, 0.6)',
					borderColor: 'rgba(75, 192, 192, 1)',
					borderWidth: 1,
					type: 'bar',

				},
				{
					label: 'Meetings Booked to Date',
					yAxisID: 'B',
					data: bar_values,
					backgroundColor: 'rgba(0, 128, 0, 0.2)', // Area fill color
					borderColor: 'rgba(0, 128, 0, 1)', // Line color
					borderWidth: 1,
					type: 'line',
					fill: true, // Enable area fill below the line
				}
			],
		};

		setBarChartData(barData);

		const doughnutData = {
			labels: Object.keys(meetingsData.meeting_type),
			datasets: [{
				data: meetingsData.meeting_count,
				backgroundColor: [
					'rgba(255, 99, 132, 0.6)',
					'rgba(54, 162, 235, 0.6)',
					'rgba(255, 206, 86, 0.6)',
					'rgba(75, 192, 192, 0.6)',
					'rgba(153, 102, 255, 0.6)',
				],
				borderColor: [
					'rgba(255, 99, 132, 1)',
					'rgba(54, 162, 235, 1)',
					'rgba(255, 206, 86, 1)',
					'rgba(75, 192, 192, 1)',
					'rgba(153, 102, 255, 1)',
				],
				borderWidth: 1
			}]
		};

		setDoughnutChartData(doughnutData);
	};

	const changeView = (companyName) => {
		setSelectedCompany(companyName);

		if (companyName === 'Overview') {
			setCurrentSeller('');
		} else {
			setCurrentSeller(data[companyName].seller);
		}

		const companyData = companyName === 'Overview' ? combinedData : data[companyName];
		const meetingsData = dataProcess(companyData.meetings);
		setBookedWeekly(meetingsData.total_count);
		setDoneWeekly(meetingsData.done_total);
		setLeadsData(leadsProcess(companyData.leads, true));
		processData(data, companyName === 'Overview' ? companyNames : [companyName]);
		//updateCharts(meetingsData);
	};

	const loadMore = async () => {
		const myButton = document.getElementsByClassName('loadMoreBttn')[0];
		myButton.disabled = true;

		const compName = selectedCompany;
		let offsets = {};
		// Use the combinedData state to get offsets
		Object.keys(combinedData).forEach(record => {
			offsets[record] = {
				offset_leads: combinedData[record].offset_leads || 'none', // Default to 0 if undefined
				offset_meetings: combinedData[record].offset_meetings || 'none' // Default to 0 if undefined
			};
		});

		const data_ = {
			token: localStorage.getItem('token'),
			token_expiry: localStorage.getItem('token_expiry'),
			username: localStorage.getItem('username'),
			offsets: offsets,
		};

		const requestOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data_)
		};

		//try {
		const response = await fetch(`${API_ENDPOINT}/loadMore.php`, requestOptions);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		const responseData = await response.json();
		localStorage.setItem('token', responseData.token);
		localStorage.setItem('token_expiry', responseData.expiry);

		// Update combinedData with new data
		Object.keys(combinedData).forEach(record => {
			if (responseData.data[record]) {
				combinedData[record].offset_leads = responseData.data[record].offset_leads;
				combinedData[record].offset_meetings = responseData.data[record].offset_meetings;

				combinedData[record].leads.push(...responseData.data[record].leads);
				combinedData[record].meetings.push(...responseData.data[record].meetings);
			}
		});

		let leads;
		let meetings_data;

		if (compName === 'Overview') {
			const combined_data = { leads: [], meetings: [] };
			Object.keys(combinedData).forEach(record => {
				combined_data.leads = combined_data.leads.concat(combinedData[record].leads);
				combined_data.meetings = combined_data.meetings.concat(combinedData[record].meetings);
			});

			meetings_data = dataProcess(combined_data.meetings);
			leads = leadsProcess(combined_data.leads);
		} else {
			const key = compName;
			meetings_data = dataProcess(combinedData[key].meetings);
			leads = leadsProcess(combinedData[key].leads);
		}

		// Update the chart data directly
		const barData = {
			labels: Object.keys(meetings_data.meeting_type), // Adjust as necessary
			datasets: [
				{
					label: 'Meetings Booked Per Week',
					data: meetings_data.meeting_count, // Adjust as necessary
					backgroundColor: 'rgba(75, 192, 192, 0.6)',
					borderColor: 'rgba(75, 192, 192, 1)',
					borderWidth: 1,
					type: 'bar',
				},
				{
					label: 'Meetings Booked to Date',
					data: meetings_data.total_count, // Adjust as necessary
					backgroundColor: 'rgba(0, 128, 0, 0.2)', // Area fill color
					borderColor: 'rgba(0, 128, 0, 1)', // Line color
					borderWidth: 1,
					type: 'line',
					fill: true, // Enable area fill below the line
				}
			],
		};

		const doughnutData = {
			labels: Object.keys(meetings_data.meeting_type),
			datasets: [{
				data: meetings_data.meeting_count,
				backgroundColor: [
					'rgba(255, 99, 132, 0.6)',
					'rgba(54, 162, 235, 0.6)',
					'rgba(255, 206, 86, 0.6)',
					'rgba(75, 192, 192, 0.6)',
					'rgba(153, 102, 255, 0.6)',
				],
				borderColor: [
					'rgba(255, 99, 132, 1)',
					'rgba(54, 162, 235, 1)',
					'rgba(255, 206, 86, 1)',
					'rgba(75, 192, 192, 1)',
					'rgba(153, 102, 255, 1)',
				],
				borderWidth: 1
			}]
		};

		// Set the chart data
		setBarChartData(barData);
		setDoughnutChartData(doughnutData);

		document.getElementById('chart_4_num').textContent = meetings_data.total_count;
		document.getElementById('chart_5_num').textContent = meetings_data.done_total;

		/*} catch (error) {
			console.error('Error loading more data:', error);
		} finally {
			myButton.disabled = false;
		}*/
	};

	const showDropDown = () => {
		let list = document.getElementsByClassName("header_list")[0];
		//change hook back to false a default and in css
		if (!dropDown) {
			list.style.display = 'grid';
		}
		else {
			list.style.display = 'none';
		}
		setDrodown(!dropDown);
	}

	const handleDownloadPDF = () => {

		showDropDown();

		const options = {
			margin: 1,
			filename: 'desktop-content.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: {
				scale: 1, // Ensures high-resolution rendering
				windowWidth: 1152, // Forces desktop-sized rendering
				windowHeight: 1080, // Forces desktop-sized rendering
			},
			margin: 0,
			jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
		};

		html2pdf().set(options).from(document.getElementById('content')).save();


	};
	const renderMeetingsTable = () => {
		if (data == null) {
			return null;
		}
		let exec_meetings = {};
		if (selectedCompany === 'Overview') {
			Object.keys(data).map(company => {
				Object.keys(data[company]['meetings']).map(meeting => {
					meeting = data[company]['meetings'][meeting];
					if (meeting['fields']['Status'] == "Executed") {
						exec_meetings[new Date(meeting['fields']['Meeting Date'])] = meeting;
						//new Date(meeting['Current Date']) > new Date(company['cutoff_date']) && meeting['fields']['Status'] === 'Executed'
						/*return (
			
						  <tr key={company + meeting + Math.random()}>
							<td>{meeting['fields']?.['Meeting Date'] ? new Date(meeting['fields']['Meeting Date']).toLocaleDateString("en-US", {
							  month: "long",
							  day: "numeric",
							  year: "numeric",
							}) : "Uknown"}</td>
							<td>{meeting['fields']?.['Meeting Name'] ? meeting['fields']['Meeting Name'] : "Uknown"}</td>
							<td>{meeting['fields']?.['Company']?.[0] ? meeting['fields']['Company'][0] : "Uknown"}</td>
							<td>{meeting['fields']?.['First Name']?.[0] && meeting['fields']?.['Last Name']?.[0] ? meeting['fields']['First Name'][0] + ' ' + meeting['fields']['Last Name'][0] : "Uknown"}</td>
							<td>{meeting['fields']?.['Position']?.[0] ? meeting['fields']['Position'][0] : "Uknown"}</td>
							<td>{meeting['fields']?.['Status'] ? meeting['fields']['Status'] : "Uknown"}</td>
							<td>{meeting['fields']?.['Decision'] ? meeting['fields']['Decision'] : "Uknown"}</td>
						  </tr>
			
						);*/
					}
				});
			})
		}
		else {
			Object.keys(data[selectedCompany]['meetings']).map(meeting => {
				meeting = data[selectedCompany]['meetings'][meeting];
				if (meeting['fields']['Status'] == "Executed") {
					exec_meetings[new Date(meeting['fields']['Meeting Date'])] = meeting;
					//new Date(meeting['Current Date']) > new Date(company['cutoff_date']) && meeting['fields']['Status'] === 'Executed'
					/*return (
		  
					  <tr key={company + meeting + Math.random()}>
						<td>{meeting['fields']?.['Meeting Date'] ? new Date(meeting['fields']['Meeting Date']).toLocaleDateString("en-US", {
						  month: "long",
						  day: "numeric",
						  year: "numeric",
						}) : "Uknown"}</td>
						<td>{meeting['fields']?.['Meeting Name'] ? meeting['fields']['Meeting Name'] : "Uknown"}</td>
						<td>{meeting['fields']?.['Company']?.[0] ? meeting['fields']['Company'][0] : "Uknown"}</td>
						<td>{meeting['fields']?.['First Name']?.[0] && meeting['fields']?.['Last Name']?.[0] ? meeting['fields']['First Name'][0] + ' ' + meeting['fields']['Last Name'][0] : "Uknown"}</td>
						<td>{meeting['fields']?.['Position']?.[0] ? meeting['fields']['Position'][0] : "Uknown"}</td>
						<td>{meeting['fields']?.['Status'] ? meeting['fields']['Status'] : "Uknown"}</td>
						<td>{meeting['fields']?.['Decision'] ? meeting['fields']['Decision'] : "Uknown"}</td>
					  </tr>
		  
					);*/
				}
			});
		}
		return Object.keys(exec_meetings)
			.map(dateStr => new Date(dateStr)) // Convert keys back to Date objects
			.sort((a, b) => a - b) // Sort chronologically
			.map(date => { // Use `.map()` instead of `.forEach()`
				const meeting = exec_meetings[date];
				return (
					<tr key={selectedCompany + meeting + Math.random()}>
						<td>{meeting['fields']?.['Meeting Date'] ? new Date(meeting['fields']['Meeting Date']).toLocaleDateString("en-US", {
							month: "long",
							day: "numeric",
							year: "numeric",
						}) : "Unknown"}</td>
						<td>{meeting['fields']?.['Meeting Name'] || "Unknown"}</td>
						<td>{meeting['fields']?.['Company']?.[0] || "Unknown"}</td>
						<td>{meeting['fields']?.['First Name']?.[0] && meeting['fields']?.['Last Name']?.[0]
							? meeting['fields']['First Name'][0] + ' ' + meeting['fields']['Last Name'][0]
							: "Unknown"}</td>
						<td>{meeting['fields']?.['Position']?.[0] || "Unknown"}</td>
						<td>{meeting['fields']?.['Status'] || "Unknown"}</td>
						<td>{meeting['fields']?.['Decision'] || "Unknown"}</td>
					</tr>
				);
			});



	};
	const get_all_data = async (type) => {
		try {
			const response = await fetch(`${API_ENDPOINT}/pull-all-data.php`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					token: localStorage.getItem('token'),
					token_expiry: localStorage.getItem('token_expiry'),
					username: localStorage.getItem('username'),
				}),
			});
			//console.log(await response.text());
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			//const resultText = await response.text();
			//console.log(resultText);
			const result = await response.json();
			if (result.success) {
				//console.log(result);
				//console.log(result.response);
				if (type) {
					exportToExcel(result.data, 'ExportedData');
				} else {
					exportToCSV(result.data, 'ExportedData');
				}

			} else {
				console.error('Error fetching data:', result.error);
			}
		} catch (error) {
			console.error('There was a problem with the fetch operation:', error);
		}
	}
	const exportToExcel = (data, fileName) => {
		if (!data || typeof data !== "object") {
			console.error("Invalid data for Excel export");
			return;
		}

		const workbook = XLSX.utils.book_new(); // Create a new workbook

		Object.keys(data).forEach((comp) => {
			const companyData = data[comp]; // Access company-level data

			// Create separate sheets for 'meetings' and 'contacts' if they exist
			if (companyData.meetings) {
				const meetingSheet = XLSX.utils.json_to_sheet(companyData.meetings);
				XLSX.utils.book_append_sheet(workbook, meetingSheet, `${comp} - Meetings`);
			}

			if (companyData.contacts) {
				const contactSheet = XLSX.utils.json_to_sheet(companyData.contacts);
				XLSX.utils.book_append_sheet(workbook, contactSheet, `${comp} - Contacts`);
			}
		});

		// Trigger file download
		XLSX.writeFile(workbook, `${fileName}.xlsx`);
	};
	const exportToCSV = async (data, fileName = "ExportedData") => {

		if (typeof data !== "object" || Object.keys(data).length === 0) {
			console.error("Invalid data for CSV export");
			return;
		}

		const zip = new JSZip();
		let fileCount = 0;

		Object.keys(data).forEach(comp => {
			const sheetData = data[comp];

			const worksheet = XLSX.utils.json_to_sheet(sheetData.meetings);
			const csvData = XLSX.utils.sheet_to_csv(worksheet);

			const worksheet2 = XLSX.utils.json_to_sheet(sheetData.contacts);
			const csvData2 = XLSX.utils.sheet_to_csv(worksheet2);

			zip.file(`${fileName}_${comp}_meetings.csv`, csvData);
			fileCount++;
			zip.file(`${fileName}_${comp}_contacts.csv`, csvData2);
			fileCount++;
		});

		// If multiple files, generate and download a ZIP
		if (fileCount > 0) {
			await zip.generateAsync({ type: "blob" }).then((content) => {
				saveAs(content, `${fileName}.zip`);
			});
		}


	};
	return (
		<div id='content'>
			<Helmet>
				<title>Home - Salesperf</title>
			</Helmet>

			{isLoading && (
				<div className='loading-icon-div'>
					<div className='loading-icon-div'>
						<p>Loading...</p>
						<div className="loading-spinner"></div>
					</div>
				</div>
			)}


			<div className="home-container">

				<div className="header">
					<div className="logo">
						<img
							className="logo_img"
							src="archive/logos/logo-salesperf.png"
							alt="SalesPerf Logo"
							style={{ display: currentSeller === '' ? 'block' : 'none' }}
						/>
						<img
							className="logo_img"
							id="IG"
							src="archive/logos/infinite-growth.png"
							alt="Infinite Growth Logo"
							onClick={() => window.open('https://www.infinitegrowth.co/', '_blank')}
							style={{ display: currentSeller === 'IG' ? 'block' : 'none' }}
						/>
						<img
							className="logo_img"
							id="NX"
							src="archive/logos/logo-nexlanding.png"
							alt="Nexlanding Logo"
							onClick={() => window.open('https://www.nexlanding.com/', '_blank')}
							style={{ display: currentSeller === 'NX' ? 'block' : 'none' }}
						/>
					</div>
					<div className='header_dropdown' >
						<div className='user_img' onClick={showDropDown}>
							<img src="archive/blank-usr.webp" />
						</div>
						<ul className='header_list'>
							<li onClick={handleDownloadPDF}><a>Save as PDF</a></li>

							<li onClick={async () => {
								get_all_data(true)
							}}><a>Export to XLSX</a></li>

							<li onClick={() => {
								get_all_data(false)
							}}><a>Export to CSV</a></li>

							<li onClick={onLogout}>
								<p>Logout</p>
								<img src="archive/logout-icon.webp" width="25" alt="Logout" style={{ paddingLeft: '5px' }} />
							</li>
						</ul>
					</div>

				</div>
				{warmLeadFilters && (
					<div className='warm-leads-filters-box-cont'>
						<div className='warm-leads-filters-exit'><p onClick={() => { setDateFilter(null); setCitiesFilter(null); setPositionFilter(null) }}>Reset</p><i className="fa-solid fa-xmark" onClick={() => setWarmLeadFilters(false)}></i></div>
						<div className='warm-leads-filters-box'>
							<div className='warm-leads-filters'>
								<div className='past-days-filter'>
									<h1 id="warm-leads-filter-title">Date Added</h1>
									<h1 onClick={() => setDateFilter(new Date(Date.now() - 24 * 60 * 60 * 1000))}>24 hours</h1>
									<h1 onClick={() => setDateFilter(new Date(Date.now() - 168 * 60 * 60 * 1000))}>This week</h1>
									<h1 onClick={() => setDateFilter(new Date(Date.now() - 730 * 60 * 60 * 1000))}>This month</h1>
								</div>
								<div className='city-filter'>
									<h1 id="warm-leads-filter-title">City</h1>
									{Array.from(cities.current).map((city, index) => (
										<h1 key={index} onClick={() => setCitiesFilter(city)}>{city}</h1>
									))}
								</div>
								<div className='position-filter'>
									<h1 id="warm-leads-filter-title">Position</h1>
									{Array.from(positions.current).map((position, index) => (
										<h1 key={index} onClick={() => setPositionFilter(position)}>{position}</h1>
									))}
								</div>
							</div>
						</div>

					</div>
				)}

				<div className="chart-container">
					<div className="chart-header">
						<h1>OVERALL REPORT</h1>
						<p>{weekRange}</p>
						<div className="company-selector" onClick={() => {
							setShowCompanies(!showCompanies);
							let comp_class = document.getElementsByClassName("company-selector")[0];
							comp_class.classList.toggle('active');
						}}>
							<span>{selectedCompany}</span>
							{showCompanies && (
								<ul className="company-list">
									{selectedCompany !== 'Overview' && (
										<li onClick={(e) => {
											e.stopPropagation();
											changeView('Overview');
											setShowCompanies(false);
										}}>Overview</li>
									)}
									{companyNames.map((company) => (
										company !== selectedCompany && (
											<li key={company} onClick={(e) => {
												e.stopPropagation();
												changeView(company);
												setShowCompanies(false);
											}}>
												{company}
											</li>
										)
									))}
								</ul>
							)}
						</div>
					</div>

					<div className="charts">
						{!isLoading && barChartData && (

							<div className="chart">
								<Bar ref={barChartRef} data={barChartData} options={barChartOptions} />
							</div>
						)}


						<div className='stat-doghnut-leads'>
							<div className="stat-box stat-1">
								<h3>Total meetings booked to date</h3>
								<h1>{bookedWeekly}</h1>
							</div>
							<div className="stat-box stat-2">
								<h3>Total meetings executed to date</h3>
								<h1>{doneWeekly}</h1>
							</div>


							{!isLoading && doughnutChartData && (
								<div className="doughnut">
									<Doughnut ref={doughnutChartRef} data={doughnutChartData} options={doughnutChartOptions} style={{ width: '100%', height: '100%' }} />
								</div>
							)}
							<div className="warm-leads">
								<h3>Warm Leads List</h3>
								<div className='warm-leads-filter-container' onClick={() => setWarmLeadFilters(true)}><img id="warm-leads-filter" src='archive/filter-icon.png' /></div>

								<div className="leads-list">
									{(selectedCompany === 'Overview'
										? leadsProcess(combinedData.leads, true)
										: leadsProcess(data[selectedCompany].leads, true)
									).map((lead, index) => (

										<div key={index} className="lead-item">
											<div className="lead-header">
												<strong>{lead.Company}</strong>
												<span>{new Date(lead['Last modified time']).toLocaleDateString()}</span>
											</div>
											<div className="lead-details">
												<p><strong>Position:</strong> {lead.Position}</p>
												{lead.City && <p><strong>City:</strong> {lead.City}</p>}
												{lead.Comment && <p><strong>Comment:</strong> {lead.Comment}</p>}
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>

					<div className="leads-table">
						<h2>Executed Meetings To Date</h2>
						<div className='leads-table-container'>
							<table id="leads-table-content">
								<thead>
									<tr>
										<th>Meeting Date</th>
										<th>Meeting Name</th>
										<th>Company</th>
										<th>Name</th>
										<th>Position</th>
										<th>Status</th>
										<th>Details</th>
									</tr>
								</thead>
								<tbody>
									{renderMeetingsTable()}
								</tbody>
							</table>
						</div>
						<button onClick={loadMore} className="loadMoreBttn">Load More</button>
					</div>
				</div>
			</div>
		</div>
	);

}
/*
  data: {
	labels: ['1', '2', '3', '4', '5'],
	datasets: [{
	  label: 'A',
	  yAxisID: 'A',
	  data: [100, 96, 84, 76, 69]
	}, {
	  label: 'B',
	  yAxisID: 'B',
	  data: [1, 1, 1, 1, 0]
	}]
  },
  options: {
	scales: {
	  yAxes: [{
		id: 'A',
		type: 'linear',
		position: 'left',
	  }, {
		id: 'B',
		type: 'linear',
		position: 'right',
		ticks: {
		  max: 1,
		  min: 0
		}
	  }]
	}
  }
*/
const barChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	scales: {
		x: {
			type: 'category',
			position: 'bottom',
			title: {
				display: true,
				text: 'Week'
			}
		},

		A: { // First Y-axis
			type: 'linear',
			position: 'left',
			title: {
				display: true,
				text: 'Meetings Per Week'
			},
		},
		B: { // Second Y-axis
			type: 'linear',
			position: 'right',
			title: {
				display: true,
				text: 'Total Meetings'
			},
			grid: {
				drawOnChartArea: false
			}
		}
	}
};

const doughnutChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	plugins: {
		doughnutLineLabel: {
			afterDraw: (chart, args, options) => {
				return { chart, args, options };
			}
		},
		legend: {
			display: false  // This will hide the legend
		},
		title: {
			display: true,
			text: 'Meetings Status',
			font: {
				size: 15
			}
		}
	},
	layout: {
		padding: 10
	},
	cutout: '70%'
};

ChartJS.register(doghnutLineLabel);

export default Home;
